<template>
  <div id="upload-image-dialog">
    <v-dialog v-model="showDialog" max-width="700">
      <div v-if="imageDetail" class="card">
        <h3>Nahranné fotky</h3>
        <v-img
          class="mb-4"
          :src="imageDetail.url"
          aspect-ratio="1.77"
          max-width="200"
        />
        <v-textarea
          outlined
          label="Popis k fotce"
          :value="imageDetail.description"
          @change="$emit('imageDescription', $event)"
        />
        <div
          class="text-right d-flex flex-column-reverse flex-sm-row justify-sm-end"
        >
          <v-btn
            class="mr-sm-2 mt-sm-0 mt-2"
            text
            @click="$emit('close-dialog')"
            >Zavřít</v-btn
          >
          <v-btn dark text class="primary-btn" @click="$emit('uploadImage')"
            >Nahrát obrázek</v-btn
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean
    },
    imageDetail: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog {
  .card {
    background-color: white;
    padding: 2rem;
  }

  .primary-btn {
    background-color: #324c8d;
  }

  @media screen and (max-width: 600px) {
    .v-btn {
      width: 100%;
      margin-top: 1rem;
    }
  }
}
</style>
